var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3197 4.82474C16.0076 4.28942 15.0977 3.96478 14.1737 4.49291C13.253 5.01912 13.091 5.94668 13.3978 6.47269L17.0811 12.7889C17.3853 13.3107 17.209 13.9804 16.6872 14.2847C16.1654 14.589 15.4956 14.4127 15.1914 13.8908L10.2803 5.46922C9.96816 4.9339 9.05844 4.60926 8.13434 5.1374C7.2136 5.66361 7.05167 6.59116 7.3584 7.11717L12.8833 16.5915C13.1876 17.1133 13.0112 17.783 12.4894 18.0874C11.9676 18.3916 11.2979 18.2152 10.9936 17.6935L8.5381 13.4826C8.22593 12.9473 7.31621 12.6227 6.39211 13.1508C5.47138 13.677 5.30944 14.6046 5.61617 15.1306L11.1411 24.6049C13.4874 28.6286 19.2775 29.9343 24.1877 27.1281C29.0945 24.3238 30.8387 18.7216 28.4978 14.7072L24.8145 8.39107C24.5024 7.85576 23.5927 7.5311 22.6685 8.05924C21.7479 8.58545 21.5859 9.51301 21.8925 10.039L24.3481 14.2498C24.4951 14.5018 24.5352 14.8022 24.4598 15.0839C24.3843 15.3657 24.1993 15.6057 23.946 15.7504C21.6965 17.0359 21.0072 19.5218 21.992 21.2105C22.2964 21.7323 22.1199 22.402 21.5981 22.7063C21.0763 23.0107 20.4066 22.8342 20.1023 22.3124C18.7713 20.0299 19.3091 17.2815 21.0283 15.3388C21.509 14.7957 21.6735 14.0058 21.3082 13.3793L16.3197 4.82474Z",
    fill: "url(#paint0_linear_135_2031)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.43615 26.0445C6.95797 25.7403 7.62766 25.9167 7.93196 26.4384C9.1378 28.5064 10.9813 30.07 13.2546 31.0847C13.8062 31.3309 14.0538 31.9776 13.8076 32.5293C13.5614 33.0809 12.9147 33.3285 12.3631 33.0823C9.72129 31.9033 7.50491 30.0485 6.04228 27.5404C5.73798 27.0186 5.91433 26.3489 6.43615 26.0445Z",
    fill: "url(#paint1_linear_135_2031)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5702 5.71958C26.0916 4.20951 23.9829 3.65251 21.9186 4.2399C21.3376 4.40521 20.7326 4.06824 20.5673 3.48724C20.402 2.90624 20.739 2.30122 21.32 2.1359C24.1465 1.33165 27.0871 2.09949 29.1333 4.18915C29.5559 4.62075 29.5486 5.31324 29.117 5.73586C28.6854 6.15848 27.9929 6.15119 27.5702 5.71958Z",
    fill: "url(#paint2_linear_135_2031)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_135_2031",
    x1: 23.4002,
    y1: 1.44744,
    x2: 2.30086,
    y2: 13.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AE9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FCDF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_135_2031",
    x1: 11.8627,
    y1: 25.0669,
    x2: 5.22876,
    y2: 29.2411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AE9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FCDF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_135_2031",
    x1: 27.1734,
    y1: 1.34221,
    x2: 22.9788,
    y2: 6.4083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AE9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FCDF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandIcon);
export default __webpack_public_path__ + "static/media/handIcon.a2542ac4b5addc28487d1d6c007be93d.svg";
export { ForwardRef as ReactComponent };